import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "image", "placeholder", "preview", "removeFlag"]

  preview() {
    if (this.inputTarget.files.length === 0) {
      return
    }
    // Re-uploading clears any pending removal mark.
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "0"
    }
    const reader = new FileReader()
    reader.onload = (event) => {
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add("d-none")
      }
      this.previewTarget.src = event.target.result
      this.previewTarget.parentElement.classList.remove("d-none")
    }
    reader.readAsDataURL(this.inputTarget.files[0])
  }

  // Marks the existing logo for purge on next form save.
  // The actual purge runs server-side via Account#after_save_commit when
  // the form submits with `account[remove_logo]=1`. Keeping this purely
  // visual avoids destroying the logo before the user commits other field
  // edits — close/cancel the page and the logo stays put.
  markForRemoval() {
    if (this.hasRemoveFlagTarget) {
      this.removeFlagTarget.value = "1"
    }
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("d-none")
    }
  }
}
